import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
  TextField
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { getArrayByKey, getArrayValuesToKeyValue } from 'helpers/dataHelpers'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Config from 'config'


const CountriesInput = (props) => {
  const {
    error,
    helperText,
    defaultValue,
    InputLabelProps,
    placeholder,
    setValue,
    value,
    className,
    multiple,
    countryVariants
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [countries, setCountries] = useState([])
  const [localValue, setLocalValue] = useState(multiple ? [] : null)

  const getCountries = () => {
    const url = `${apiUrl}countries/`
    axios.get(url).then((body) => {
      const { data } = body
      setCountries(data)
    }).catch(error => {
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  useEffect(() => {
    if (typeof countryVariants === 'undefined') {
      getCountries()
    } else {
      setCountries(getArrayValuesToKeyValue(countryVariants, 'name'))
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (defaultValue) {
      if (!multiple) {
        return setLocalValue({name: defaultValue})
      }
      return setLocalValue(getArrayValuesToKeyValue(defaultValue, 'name'))
    }
    if (multiple) {
      return setLocalValue([])
    }
    return setLocalValue(null)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (multiple && value !== undefined) {
      const prepared = []
      value.forEach(el => prepared.push({ name: el }))
      setLocalValue(prepared)
    }
  }, [value]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event, newValue) => {
    if (setValue) {
      if (multiple) {
        setValue(getArrayByKey(newValue, 'name'))
      } else {
        setValue(newValue.name)
      }
    }
    if (multiple) {
      setLocalValue(newValue)
    } else {
      setLocalValue(newValue)
    }
  }

  const setDefaultValue = () => {
    if (defaultValue) {
      if (!multiple) {
        setValue(defaultValue)
        return {name: defaultValue}
      }
      return getArrayValuesToKeyValue(defaultValue, 'name')
    }
    if (multiple) {
      return []
    }
    return null
  }

  return (
    <Autocomplete
      onChange={handleChange}
      value={localValue}
      className={className ? className : ''}
      getOptionSelected={(option, value) => option.name === value.name}
      options={countries}
      autoHighlight
      fullWidth
      multiple={!!multiple}
      filterSelectedOptions
      defaultValue={setDefaultValue()}
      getOptionLabel={(country) => country.name}
      renderOption={(country) => (
        <React.Fragment>
          {country.name}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Country'
          variant='outlined'
          color='secondary'
          fullWidth
          required
          error={error}
          helperText={helperText}
          name='country'
          InputLabelProps={InputLabelProps}
          placeholder={placeholder || 'Countries...'}
        />
      )}
    />
  )
}

export default CountriesInput
